import { MetricField } from "../../gql-generated/types";

/**
 * Mapping Between Audience tab and MetricField to use for insights breakdown
 */
export const audienceTabsMetricsMap: Record<number, MetricField> = {
    0: MetricField.LensViews,
    1: MetricField.LensPlays,
};
